<template>
    <div class="mt-2 space-x-4 flex">
        <div
            class="bg-gray-light border border-gray-dark flex rounded-md shadow-sm"
        >
            <div class="flex items-center px-2">
                <label for="operator" class="sr-only">Action</label>
                <select
                    id="operator"
                    name="operator"
                    class="p-2 bg-transparent border-transparent h-full rounded-md sm:text-sm outline-none font-bold"
                    v-model="action"
                    @change="selectAction"
                >
                    <option value="allow">Allow</option>
                    <option value="deny">Block</option>
                    <!-- <option value="spell.reply" v-if="onBleedingEdge">Auto-reply</option> -->
                    <option value="spell.magazine">
                        Add to magazine
                    </option>
                    <!-- <option value="spell.forward">Auto-forward</option>
                    <option value="spell.folder">Apply label</option> -->
                </select>
            </div>
        </div>
        <div class="flex-1"></div>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'allow'
        },
    },
    data() {
        return {
            action: this.type,
        };
    },
    computed: {},
    methods: {
        selectAction(event) {
            this.$emit('change', event.target.value);
        }
    },
};
</script>

<style scoped>
</style>
